import React, { useRef, useState } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import "./Tooltip.scss";
import classNames from "classnames";

export const Tooltip = ({ content, children, style }) => {
  const [tooltipPosition, setTooltipPosition] = useState(null);
  const tooltipRef = useRef(null);
  const portalContainer = document.body;

  const calculateTooltipPosition = (childElement) => {
    const tooltipElement = tooltipRef.current;

    if (childElement && tooltipElement) {
      const { top, left, width, height } = childElement.getBoundingClientRect();

      const tooltipTop = top - tooltipElement.offsetHeight - height / 2;
      const tooltipLeft = left + width / 2;

      return { top: `${tooltipTop}px`, left: `${tooltipLeft}px` };
    }

    return { top: 0, left: 0 };
  };

  return (
    <div
      className="tooltip-component"
      onMouseEnter={(e) => {
        const position = calculateTooltipPosition(e.currentTarget);
        setTooltipPosition(position);
      }}
      onMouseLeave={() => setTooltipPosition(null)}
      style={style}
    >
      {children}
      {ReactDOM.createPortal(
        <div
          ref={tooltipRef}
          className={classNames("tooltip-component-content", {
            hidden: tooltipPosition === null,
          })}
          style={tooltipPosition}
          data-testid="TooltipContentId"
        >
          {content}
        </div>,
        portalContainer
      )}
    </div>
  );
};

Tooltip.propTypes = {
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  children: PropTypes.node.isRequired,
  style: PropTypes.shape({
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};
